export const BACKEND_API_ENDPOINT = 'https://invest.leasing.express:8080/api'
